export const EBOOK_PDF_PUBLIC_DIR = {
    km: "/static-km/pdf/ebooks",
    rp: "/static-rp/pdf/rebranding"
} as const;

export type EbookHostApp = keyof typeof EBOOK_PDF_PUBLIC_DIR;

export const getEbookDownloadUrl = (fileName: string, app: EbookHostApp) => `${EBOOK_PDF_PUBLIC_DIR[app]}/${fileName}`;
export const EBOOK_PDF_PUBLIC_DIR = {
    km: "/static-km/pdf/ebooks",
    rp: "/static-rp/pdf/rebranding"
} as const;

export type EbookHostApp = keyof typeof EBOOK_PDF_PUBLIC_DIR;

export const getEbookDownloadUrl = (fileName: string, app: EbookHostApp) => `${EBOOK_PDF_PUBLIC_DIR[app]}/${fileName}`;
